module.exports = __webpack_public_path__ + "static/bg-prosperity-b6934ebde07c6e5c2ad138c4a62ea751.webp";